
import Vue, { PropType } from 'vue'
import StaticBlocks, { Static } from '../static-blocks'

import { COMPONENT_PARAMS } from '~/constants/components'

export default Vue.extend({
  name: 'RecursiveComponent',
  components: {
    ...StaticBlocks
  },
  props: {
    /**
     * Данные статического блока
     */
    block: {
      type: Object as PropType<Static.Static>,
      required: true
    },
    /**
     * Статус, является ли корневым блоком
     */
    isRoot: {
      type: Boolean,
      required: false,
      default: false
    },

    pageTitle: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    /**
     * Блоки по текущему id сайта
     */
    currentSiteBlocks () {
      return (
        this.block?.items?.filter(
          el =>
            !el?.siteId?.length || el?.siteId?.includes(this.$authNew.siteId)
        ) || []
      )
    },
    /**
     * Поля статического блока
     */
    blockFields () {
      return {
        blocks: this.block?.fields?.blocks || [],
        mainFields: this.block?.fields?.mainFields || []
      }
    },
    /**
     * Параметры статического блока
     */
    blockParams (): NComponentsParams.IComponentParams {
      return Object.assign({}, COMPONENT_PARAMS, this.block?.params)
    },
    /**
     * Заголовок статического блока
     */
    blockTitle () {
      return this.block?.title || ''
    },

    blocksRatio () {
      const values: number[] =
        this.blockParams?.blocksRatio?.split('/')?.map(Number) || []
      return {
        values,
        sum: values?.reduce((acc, curr) => {
          acc += curr
          return acc
        }, 0)
      }
    },

    calculatedFlex () {
      return (idx: number) => {
        if (!this.blockParams.isHorizontal) {
          return ''
        }
        if (this.blocksRatio?.values?.length) {
          return `flex: ${
            (1 / this.blocksRatio?.sum) *
            this.blocksRatio?.values[idx % (this.blockParams?.blockPerRow || 1)]
          }`
        }
        if (this.currentSiteBlocks?.length <= 1) {
          return 'flex: 1'
        }
        return `flex: ${1 / this.currentSiteBlocks?.length}`
      }
    }
  },
  methods: {
    redirect () {
      if (!this.blockParams?.isUrl) {
        return
      }

      if (this.blockParams?.redirectUrl?.startsWith('https://')) {
        window.open(this.blockParams?.redirectUrl, '_blank')
      } else {
        this.$router.push(this.blockParams?.redirectUrl)
      }
    }
  }
})
